import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { inisNodesFixture } from './fixture';

/**
 * INIS-Knotenverwaltung (#226). Operator-Endpoints unter /v1/inis (M2M passiert).
 *   GET  /v1/inis/nodes
 *   POST /v1/inis/nodes/:hardwareUuid/assign   { role, targetHostname }
 *   POST /v1/inis/nodes/:hardwareUuid/deassign
 */
export function useInisNodes() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['nexus-inis-nodes', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return inisNodesFixture(); }
      return nexusFetch('/v1/inis/nodes');
    },
    staleTime: 15_000,
  });
}

export function useAssignInisNode() {
  return useApiMutation({
    live: (_fetch, { hardwareUuid, role, targetHostname }) =>
      nexusFetch(`/v1/inis/nodes/${encodeURIComponent(hardwareUuid)}/assign`, {
        method: 'POST',
        body: { role, targetHostname },
      }),
    fixture: ({ hardwareUuid, role, targetHostname }) => ({ node: { hardwareUuid, role, targetHostname, status: 'assigned' } }),
    invalidate: ['nexus-inis-nodes'],
    successMessage: (res) => `Rolle zugewiesen: ${res?.node?.targetHostname ?? ''} (${res?.node?.role ?? ''}).`,
  });
}

export function useDeassignInisNode() {
  return useApiMutation({
    live: (_fetch, { hardwareUuid }) =>
      nexusFetch(`/v1/inis/nodes/${encodeURIComponent(hardwareUuid)}/deassign`, { method: 'POST' }),
    fixture: () => ({ ok: true }),
    invalidate: ['nexus-inis-nodes'],
    successMessage: () => 'Zuweisung aufgehoben.',
  });
}
